<template>
  <content-area :items="items" />
</template>

<script>
import ContentArea from '@/components/ContentArea.vue'

export default {
  components: {
    ContentArea
  },
  computed: {
    info () {
      return this.$store.getters['hsm/GET_INFO']
    },
    items () {
      const info = this.info
      let items = []
      if (info) {
        items = [
          {
            title: this.$tc('manufacturer'),
            data: info.manufacturerID,
            testId: 'manufacturer'
          },
          {
            title: this.$tc('model'),
            data: info.model,
            testId: 'model'
          },
          {
            title: this.$tc('hw_profile'),
            data: info.hardwareVersion,
            testId: 'profile'
          },
          {
            title: this.$tc('firmware_version'),
            data: info.firmwareVersion,
            testId: 'firmware_version'
          },
          {
            title: this.$tc('serial'),
            data: info.serialNumber,
            testId: 'serial'
          },
          {
            title: this.$tc('tp_key'),
            data: info.tpkey,
            testId: 'tp_item'
          },
          {
            title: this.$tc('alias'),
            data: info.hsm_alias ? info.hsm_alias : this.$tc('none', 2),
            testId: 'alias'
          },
          {
            title: this.$tc('loaded_module'),
            data: info.mods,
            testId: 'loaded_module'
          },
          {
            title: this.$tc('sc_reader'),
            data: info.ScReader,
            testId: 'sc_reader'
          }
        ]
        if (!info.tpkey) {
          const tpoemItem = {
            title: this.$tc('tp_oem'),
            data: info.tpoem,
            testId: 'tp_item'
          }
          const hasTPKey = (element) => element.testId === 'tp_item'
          const index = items.findIndex(hasTPKey)
          items.splice(index, 1, tpoemItem)
        }
      }
      return items
    }
  }
}
</script>

<style lang="scss" scoped>
.v-card {
  background-color: transparent;
}
</style>
